import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/Layout';
import { authdApiRequest } from '../utils/api';

function ChangePassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }

    try {
      const response = await authdApiRequest(`${process.env.REACT_APP_API_HOST}/auth/changepassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        toast.success('Password changed successfully!');
        navigate('/dashboard');
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || 'Failed to change password.');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      toast.error('An error occurred. Please try again.');
    }
  };

  return (
    <Layout>
      <h1 className="text-2xl text-center font-bold mb-8">Change Password</h1>
      <div className="max-w-prose mx-auto text-center">
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="p-2 border rounded-md"
            required
          />
          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="p-2 border rounded-md"
            required
          />
          <button type="submit" className="p-2 bg-sky-500 text-white rounded-md">
            Change Password
          </button>
        </form>
      </div>
    </Layout>
  );
}

export default ChangePassword;
